"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var _reactRedux = require("react-redux");
var _translation = _interopRequireDefault(require("../../Translation/translation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelInputScale = props => {
  const {
    className = '',
    disabled = false,
    hideMessage = false,
    iconSize = 'normal',
    input,
    label = null,
    lang = 'en',
    modal = null,
    options,
    centered,
    readOnly,
    showMinMaxLabelValue = false,
    translations,
    validation = false
  } = props;
  const [hoverLabel, setHoverLabel] = (0, _react.useState)(null);
  const [hoverVal, setHoverVal] = (0, _react.useState)(null);
  const selectedOpt = options ? options.find(item => item.value === input.value) : '';
  const clickOption = (_e, val) => {
    if (!disabled && input.onChange && options.length > 0 && !readOnly) {
      if (input.value === val) input.onChange(val);else input.onChange(val);
    }
  };
  const enterState = (e, val) => {
    e.preventDefault();
    if (!disabled && !readOnly) {
      setHoverLabel(val.label);
      setHoverVal(val.value);
    }
  };
  const leaveState = e => {
    e.preventDefault();
    setHoverLabel(null);
    setHoverVal(null);
  };
  const iconSizes = () => {
    switch (iconSize) {
      case 'large':
        return 'w-fix-44';
      default:
        return '';
    }
  };
  const checkIsActive = val => {
    if (input.invertScale) {
      if (input.value && +input.value <= +val.value && !hoverVal || hoverVal && hoverVal <= val.value || hoverVal && input.value && +input.value <= +val.value && +hoverVal > +val.value) {
        return true;
      }
    } else if (input.value && +input.value >= +val.value && !hoverVal || hoverVal && hoverVal >= val.value) {
      return true;
    }
    return false;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-step-container ${className}`
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    "data-testid": "label",
    "aria-label": "label",
    className: "brixel-label mb-0"
  }, label)), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col"
  }, !hideMessage && (/*#__PURE__*/_react.default.createElement("span", {
    className: "message"
  }, "Levels from ", options[0].label, " to ", options[options.length - 1].label)), /*#__PURE__*/_react.default.createElement("div", {
    className: `dis-f ml-1-neg ${centered ? 'jc-c' : ''}`
  }, options.map((val, i) => (/*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `opt_${i.toString()}`
  }, /*#__PURE__*/_react.default.createElement("input", {
    "data-validation": validation,
    defaultValue: input.value,
    name: input.name
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `step ${checkIsActive(val) ? 'active' : 'inactive'} ${disabled ? 'disabled' : ''} ta-c pos-r`,
    onClick: e => clickOption(e, val.value),
    onMouseEnter: e => enterState(e, val),
    onMouseLeave: e => leaveState(e)
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: "star-fill",
    color: checkIsActive(val) ? 'primary' : 'text',
    saturationTxt: checkIsActive(val) ? 400 : 100,
    iconWidth: iconSizes()
  }), (!input.value || +input.value < 0) && showMinMaxLabelValue && (i === 0 || i === options.length - 1) && !readOnly && (/*#__PURE__*/_react.default.createElement("p", {
    className: `ta-c pos-a x-c  fsize-300 ws-nw trans-op txtText500 ${iconSize === 'large' ? 'mt-6' : 'mt-3'} ${!hoverVal ? 'opacity10' : 'opacity0'}`
  }, (0, _translation.default)(val.label.toString(), lang, null, translations))), showMinMaxLabelValue && (/*#__PURE__*/_react.default.createElement("label", {
    className: `dis-b ta-c pos-a x-c fsize-300 ws-nw txtText900 ${iconSize === 'large' ? 'mt-6' : 'mt-3'} ${input.value === val.value && !hoverVal || hoverLabel === val.label ? 'opacity10' : 'opacity0'}`
  }, (0, _translation.default)(val.label.toString(), lang, null, translations)))))))), !showMinMaxLabelValue && (/*#__PURE__*/_react.default.createElement("div", {
    className: "pos-r h-fix-32 dis-f a-c"
  }, hoverLabel ? (/*#__PURE__*/_react.default.createElement("label", {
    className: ""
  }, hoverLabel)) : (/*#__PURE__*/_react.default.createElement("label", {
    className: " fweight-500"
  }, selectedOpt && selectedOpt.label))))), modal && (/*#__PURE__*/_react.default.createElement("span", {
    onClick: e => modal.func ? modal.func(e) : '',
    className: `message ${modal.func ? 'cur-poi' : ''} ${modal.className || ''}`,
    dangerouslySetInnerHTML: {
      __html: modal.message || ''
    }
  })));
};
const mapStateToProps = state => ({
  translations: (0, _lodash.get)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(BrixelInputScale);